export const ENDPOINTS = {

  //UA-CLOUD
  GET_MY_EVENTS: '/get-my-event',
  GET_MY_NOTICES: '/get-my-notices',
  GET_MY_SERVICES: '/get-my-services',
  GET_OFFICE_CALENDAR: '/get-week-events',
  MENU_BANNER: '/menu-banner',
  MENU_SHORTCUTS: '/menu-shortcuts',
  GET_FAQ_CATEGORIES: '/get-faq-categories',
  GET_FAQ_QUESTIONS: '/get-questions',
  FILTER_QUESTIONS: '/filter-questions',
  ALL_QUESTIONS: '/all-questios',
  OFFICE_APPS: '/get-office-apps',
  PERIODS: '/get-list-of-periods',
  NOTES: '/get-list-of-notes',
  GLOBAL: '/global',
  IMAGE_LOGIN: '/get-image-login',

  //!UA-IA

  //Prompts
  GET_NAVIGATNION: '/get-navigation',
  GET_PROMPTS:'/get_prompts',
  GET_QUESTIONS:'/get-questions',
  GET_CAREERS:'/get-careers',
  CREATE_PROMPT:'/create-prompt',
  TEST_PROMPT:'/test-prompt',
  EDIT_PROMPT:'/edit-prompt',

  //Evaluations
  CREATE_EVALUATION:'/create-evaluation',
  GET_EVALUATIONS:'/get-evaluations',
  EDIT_EVALUATION:'/edit-evaluation',
  EDIT_QUESTION:'/edit-questions',
  DELETE_QUESTION:'/delete-questions',
  CREATE_QUESTION:'/create-questions',
  GET_PROMPTS_NAME:'/get-prompts-names',
  GET_GRUPO_ALUMNOS:'/find-grupo-alumno',
  GET_EVALUATION_DETAILS:'/get_evaluations_details',
  CREATE_DESTINATARIOS:'/create_evaluacion_respuesta',
  FIND_EVALUATION_ANSWER:'/find_evaluations_answers',
  FIND_STUDENT_ANSWER:'/get_students_answers',
  FIND_STUDENT_GRADE:'/get_students_grade',
  PUT_EVALUADOR_FEEDBACK:'/put_evaluador_feedback',
  CREATE_GRUPO_ALUMNOS:'/create_grupo_alumnos',
  EDIT_GRUPO_ALUMNOS:'/edit_grupo_alumnos',
  FIND_GROUP_BY_ID:'/find_student_group_by_id',
  DELETE_GROUP:'/delete_grupo_alumnos',
  GET_BIENVENDA:'/get_bienvenida_by_role',
  GET_DASHBOARD_STATS:'/get_dashboard_stats_by_role',
  GET_EVALUATIONS_BY_USER:'/get_evaluations_by_user',
  TAKE_EVALUATION:'/take_evaluation',
  RESPOND_EVALUATION:'/create_respuestas_by_alumno',
  EVALUATION_DETAILS:'/get_evaluation_detail_by_student',
  SEND_CREATION_NOTIFICATION:'/cron-envio-email-evaluacion',
  SEND_EVALUATE_NOTIFICATION:'/Cron-Envio-Email-Nota',




//STUDENTS
  GET_STUDENTS_SELECT:'/get_students_select',




}
